import React from "react";
import zxcvbn from "zxcvbn";

import * as S from "./password.strength.styles";
import { StrengthText, StrengthColor } from "./constants";
export const PasswordStrengthMeter = (password) => {
  const result = zxcvbn(password.value);
  const score = (result.score * 100) / 4;

  return (
    <div>
      <S.PasswordMeter
        variant="success"
        color={StrengthColor[result.score]}
        now={score}
      />
      <S.PasswordLabel color={StrengthColor[result.score]}>
        {StrengthText[result.score]}
      </S.PasswordLabel>
    </div>
  );
};
